import React from 'react';

const PlayIcon: React.FC<{
  className?: string;
  width?: string;
  height?: string;
}> = ({ className, width = 30, height = 30 }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      className={className}
      viewBox="0 0 30 30"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15 30C23.2843 30 30 23.2843 30 15C30 6.71573 23.2843 0 15 0C6.71573 0 0 6.71573 0 15C0 23.2843 6.71573 30 15 30ZM11 11.1326C11 10.0664 12.1566 9.40274 13.0773 9.94088L20.4552 14.2531C21.2343 14.7084 21.2343 15.8344 20.4552 16.2897L13.0773 20.6019C12.1566 21.1396 11 20.4759 11 19.4102V11.1326Z"
        fill="#1C2DEF"
      />
    </svg>
  );
};

export default PlayIcon;
